var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00021,
    cy: 8.00021,
    r: 7.16818,
    fill: "#47B749",
    stroke: "#47B749",
    strokeWidth: 1.14286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3096 6.20412L6.78943 11.0675L4.71143 8.98951",
    stroke: "white",
    strokeWidth: 1.48571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedFilled);
export default __webpack_public_path__ + "static/media/accepted_filled.820083af6a2d5cebd55dc07929da82bb.svg";
export { ForwardRef as ReactComponent };